import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest} from "@api/ApiService";
import {ProjectSettings} from "@lib/Project/ProjectModels";
import {FlatTranslations} from "@i18n/project/bundle";
import {Lang} from "@i18n/language";

const ROUTES = {
    GET_CONFIG: {
        path: API_ROUTES.GET_PROJECT_BY_COUNTRY,
        module: API_MODULES.EXT,
        solution: API_SOLUTIONS.MZ
    },
    GET_TRANSLATIONS: {
        path: API_ROUTES.GET_TRANSLATIONS,
        module: API_MODULES.SOLUTION,
        solution: API_SOLUTIONS.MZ
    },
}

class ProjectService {

    static getByCountry = async (countryCode: string): Promise<ProjectSettings> => {

        const url = generateApiEndpoint({
            ...ROUTES.GET_CONFIG,
            params: {countryCode}
        });

        return await getRequest<ProjectSettings>(url);
    }

    static getTranslations = async (lang: Lang): Promise<FlatTranslations> => {

        const url = generateApiEndpoint({
            ...ROUTES.GET_TRANSLATIONS,
            params: {lang: `${lang.toLowerCase()}.json`}
        });

        return await getRequest<FlatTranslations>(url);
    }

}

export default ProjectService;